import { HostListener, Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
/**
 * This Serivce abstracts the translation service used in the application. It provides a method to translate keys into the current language.
 * It is designed to be used in components and services that need to display translated text.
 * So the Translation Dependency can be easily swapped out in the future if needed, without changing the components that use it.
 *
 * @example
 * ```typescript
 * constructor(private translateService: DtisTranslateService)
 */
export class DtisTranslateService {
  private readonly translocoService = inject(TranslocoService);
  private readonly snack = inject(MatSnackBar);

  constructor() {
    console.log('DtisTranslateService initialized');
  }

  // Set Hot Key to swap between languages fast, for example: Ctrl + Shift + L
  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (event.ctrlKey && event.shiftKey && event.key === 'L') {
      const currentLang = this.translocoService.getActiveLang();
      const newLang = currentLang === 'en' ? 'de' : 'en';
      this.translocoService.setActiveLang(newLang);
      this.snack.open(`Language switched to ${newLang}`, 'Close', { duration: 2000 });
    }
  }
  translate(key: string): string {
    return this.translocoService.translate(key);
  }

  switchLanguage(lang: string): void {
    this.translocoService.setActiveLang(lang);
  }

  switchDefaultLanguage(lang: string): void {
    this.translocoService.setDefaultLang(lang);
  }
}
